import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const FooterWrapper = styled.footer`
    display: grid;
    gap: 20px;
    grid-template-columns: auto auto auto auto;
    justify-content: center;
    padding: 12px 0px 10px;
    position: relative;
    width: 100%;
`;

export const FooterLink = styled.a<{ hideLastDivider?: boolean }>(
    ({ hideLastDivider, theme: { fontSize, palette } }) => css`
        color: ${palette.text.assistive};
        cursor: pointer;
        font-size: ${fontSize[12]}px;
        line-height: 20px;
        position: relative;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
            text-underline-position: under;
        }

        &:after {
            content: '|';
            position: absolute;
            right: -10px;
            top: 0;
        }

        &:last-of-type:after {
            ${hideLastDivider &&
            css`
                display: none;
            `}
        }
    `,
);

export const ReleaseVersion = styled(Typography.TextBody_12_20)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
    `,
);
